import validate from "E:/W2/CDVM_V2/VM.Cms/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "E:/W2/CDVM_V2/VM.Cms/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}